require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-c-1-ja-8-zs-bod-mf-y-lz-7-rd-6-v-4-ku.json") })
        }
      }, "path---news-c-1-ja-8-zs-bod-mf-y-lz-7-rd-6-v-4-ku");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-c-1-ja-8-zs-bod-mf-y-lz-7-rd-6-v-4-ku!./.cache/json/news-c-1-ja-8-zs-bod-mf-y-lz-7-rd-6-v-4-ku.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-c-1-ja-8-zs-bod-mf-y-lz-7-rd-6-v-4-ku!./.cache/json/news-c-1-ja-8-zs-bod-mf-y-lz-7-rd-6-v-4-ku.json
// module chunks = 231608221292675